import type { Logger } from '@devhacker/shared/libs/logger';
import { API_URL, API_URL_PREFIX, API_TIMEOUT } from '~/constants/config';
import type {
  IArchivesApi,
  ICategoryPayload,
  ITopPayload,
  ITagPayload,
  IAuthorPayload,
  ISearchPayload,
  IPayloadArchives,
} from '~/types/api/archives';
import { createAxiosLikeFetch } from '@devhacker/shared/libs/fetch/createAxiosLikeFetch';
import { createLoggerInterceptors } from '@devhacker/shared/libs/logger';

type Params = {
  $logger: Logger;
};

export default ({ $logger }: Params): IArchivesApi => {
  const archivesFetch = createAxiosLikeFetch({
    baseURL: `${API_URL}${API_URL_PREFIX}`,
    timeout: API_TIMEOUT,
    credentials: 'include',
    ...createLoggerInterceptors($logger, 'archives'),
  });

  return {
    // top
    // curl --location --request OPTIONS 'https://stage.burninghut.ru/wp-json/bh-kiss/v1/top/(?P<period>(day|week|month|year|all))'
    // example: curl --location --request OPTIONS 'https://stage.burninghut.ru/wp-json/bh-kiss/v1/top/week'
    top(payload: ITopPayload) {
      const { period, limit, page } = payload;
      const params = { limit, page };

      return archivesFetch(`top/${period}`, { params });
    },

    // home posts
    // curl --location --request OPTIONS 'https://stage.burninghut.ru/wp-json/bh-kiss/v1/home-posts'
    homePosts(payload?: IPayloadArchives, withCookie: boolean = false) {
      return archivesFetch('home-posts', {
        params: payload,
        // нужно для того, чтобы авторизационная кука отправилась
        // и в ответе пришел валидный is_user_logged_in
        headers: withCookie ? { cookie: useRequestHeader('cookie') as string } : {},
      });
    },

    // category
    // curl --location --request OPTIONS 'https://stage.burninghut.ru/wp-json/bh-kiss/v1/category/(?P<slug>.+)'
    category(payload: ICategoryPayload) {
      const { slug, limit, page } = payload;
      const params = { limit, page };

      return archivesFetch(`category/${slug}`, { params });
    },

    // tag
    // curl --location --request OPTIONS 'https://stage.burninghut.ru/wp-json/bh-kiss/v1/tag/(?P<slug>.+)'
    tag(payload: ITagPayload) {
      const { slug, limit, page } = payload;
      const params = { limit, page };

      return archivesFetch(`tag/${slug}`, { params });
    },

    // author
    // curl --location --request OPTIONS 'https://stage.burninghut.ru/wp-json/bh-kiss/v1/author/(?P<slug>.+)'
    author(payload: IAuthorPayload) {
      const { slug, limit, page } = payload;
      const params = { limit, page };

      return archivesFetch(`author/${slug}`, { params });
    },

    // search
    // curl --location --request OPTIONS 'https://stage.burninghut.ru/wp-json/bh-kiss/v1/search'
    search(payload: ISearchPayload) {
      return archivesFetch('search', { params: payload });
    },
  };
};
